import EditUserByAdmin from "./EditUserByAdmin";

export default EditUserByAdmin;
